import { jsx as i } from "react/jsx-runtime";
import m from "classnames";
import "./main.scss";
const t = (l, o = !1, r = !1) => l == null || !o && (l === 0 || l === "0") ? "--" : Number(l).toLocaleString(void 0, {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: r ? 0 : 2
}), f = ({
  amount: l = void 0,
  showZeroValue: o = !1,
  hideCents: r = !1,
  large: s = !1,
  className: a = void 0,
  style: e = void 0
}) => /* @__PURE__ */ i(
  "div",
  {
    className: m(
      "sds_dollar-amount",
      {
        "sds_dollar-amount--large": s
      },
      a
    ),
    style: e,
    children: t(l, o, r)
  }
);
export {
  f as DollarAmount,
  t as formatDollarAmount
};
//# sourceMappingURL=index.js.map
